module.exports = __webpack_public_path__ + "img/1455801952.0b4a9b28.jpg";